(() => {
  const init = () => {
    document.querySelectorAll('[data-ps-home]').forEach((home) => {
      if (home.dataset.psReady === 'true') return;
      home.dataset.psReady = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = home.querySelectorAll('[data-ps-reveal]');
      if ('IntersectionObserver' in window && !reducedMotion) {
        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        reveals.forEach((item) => revealObserver.observe(item));
      } else {
        reveals.forEach((item) => item.classList.add('is-revealed'));
      }

      const sequence = home.querySelector('[data-ps-sequence]');
      const frames = sequence ? [...sequence.querySelectorAll('.ps-sequence__frame')] : [];
      const steps = sequence ? [...sequence.querySelectorAll('.ps-sequence__steps li')] : [];
      const sequenceVideo = sequence ? sequence.querySelector('[data-ps-sequence-video]') : null;
      const stage = sequence ? sequence.querySelector('.ps-sequence__stage') : null;
      let activeFrame = -1;
      const setFrame = (index) => {
        if (index === activeFrame) return;
        activeFrame = index;
        frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
        steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      };

      const sticky = sequence ? sequence.querySelector('.ps-sequence__sticky') : null;
      const stickyBuy = home.querySelector('[data-ps-sticky-buy]');
      let ticking = false;
      const update = () => {
        ticking = false;
        if (stage && sticky && steps.length) {
          const rect = stage.getBoundingClientRect();
          const travel = Math.max(stage.offsetHeight - sticky.offsetHeight, 1);
          const progress = Math.min(1, Math.max(0, -rect.top / travel));
          setFrame(Math.min(steps.length - 1, Math.floor(progress * steps.length)));
          if (sequenceVideo && Number.isFinite(sequenceVideo.duration) && sequenceVideo.duration > 0) {
            const targetTime = progress * Math.max(sequenceVideo.duration - 0.05, 0);
            if (Math.abs(sequenceVideo.currentTime - targetTime) > 0.08) sequenceVideo.currentTime = targetTime;
          }
        }
        if (stickyBuy) stickyBuy.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.75);
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
